/** Alert — inline banner for system/page messages. */
import { CheckCircle2, Info, AlertTriangle, XCircle, Wrench } from "lucide-react";
import { cn } from "../../lib/cn";

const variants = {
  success: { Icon: CheckCircle2, c: "border-sage/40 bg-sage/10 text-text", iconCls: "text-sage" },
  info: { Icon: Info, c: "border-mauve/30 bg-mauve/10 text-text", iconCls: "text-mauve" },
  warning: { Icon: AlertTriangle, c: "border-gold/40 bg-gold/10 text-text", iconCls: "text-gold" },
  error: { Icon: XCircle, c: "border-red-500/40 bg-red-500/10 text-text", iconCls: "text-red-400" },
  maintenance: { Icon: Wrench, c: "border-line-2 bg-surface text-text", iconCls: "text-mauve" },
};

export function Alert({ variant = "info", title, children, className, action, ...props }) {
  const { Icon, c, iconCls } = variants[variant] || variants.info;
  return (
    <div
      role="alert"
      className={cn("flex gap-3 p-4 rounded-[16px] border", c, className)}
      data-testid={`alert-${variant}`}
      {...props}
    >
      <Icon size={18} className={cn("flex-shrink-0 mt-0.5", iconCls)} />
      <div className="flex-1 min-w-0">
        {title && <p className="font-semibold text-[14px] mb-0.5">{title}</p>}
        {children && <div className="text-[13.5px] text-text-dim leading-relaxed">{children}</div>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}
